import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { saveBetaalmethode } from '../Reducers/actions';
import { renderField, renderselect, rendercheckbox } from '../../../../Components/Forms/renders';
import { required } from 'redux-form-validators';
import SwitcButton from '../../../../Components/Forms/switch';
import Modal from "../../../../Components/Modal";

const BetaalmethodeForm = ({ 
  provider, 
  onClose, 
  existingConfig, 
  handleSubmit, 
  saveBetaalmethode,
  submitting 
}) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (formValues) => {
    setLoading(true);
    
    const betaalmethodeData = {
      naam: provider,
      actief: formValues.actief || false,
      configuratie: {},
      extra_instellingen: {
        webhook_url: formValues.webhook_url || '',
        redirect_url: formValues.redirect_url || '',
        beschrijving: formValues.beschrijving || ''
      }
    };

    // Provider-specific configuration
    if (provider === 'mollie') {
      betaalmethodeData.configuratie = {
        mollie_api_key: formValues.mollie_api_key || '',
        mollie_test_mode: formValues.mollie_test_mode || false
      };
    } else if (provider === 'paynl') {
      betaalmethodeData.configuratie = {
        paynl_token: formValues.paynl_token || '',
        paynl_service_id: formValues.paynl_service_id || '',
        paynl_terminal_code: formValues.paynl_terminal_code || '',
        paynl_test_mode: formValues.paynl_test_mode || false
      };
    }

    const result = await saveBetaalmethode(betaalmethodeData);
    
    if (result.success) {
      onClose();
    }
    
    setLoading(false);
  };

  const renderMollieFields = () => (
    <>
      <div className="row">
        <div className="col-12">
          <Field
            name="mollie_api_key"
            component={renderField}
            type="password"
            label="Mollie API Key"
            placeholder="live_... of test_..."
            validate={[required({ msg: 'API Key is verplicht' })]}
            helpText="Je vindt deze in je Mollie Dashboard onder Developers > API keys"
          />
        </div>
      </div>
      
      <div className="row">
        <div className="col-12">
          <Field
            name="mollie_test_mode"
            component={SwitcButton}
            type="checkbox"
            label="Test modus"
            helpText="Schakel dit uit voor live betalingen"
          />
        </div>
      </div>
    </>
  );

  const renderPaynlFields = () => (
    <>
      <div className="row">
        <div className="col-md-6">
          <Field
            name="paynl_token"
            component={renderField}
            type="password"
            label="Pay.nl API Token" 
            placeholder="AT-####-####"
            validate={[required({ msg: 'API Token is verplicht' })]}
            helpText="API token uit je Pay.nl beheeromgeving"
          />
        </div>
        <div className="col-md-6">
          <Field
            name="paynl_service_id"
            component={renderField}
            type="text"
            label="Service ID"
            placeholder="SL-####-####"
            validate={[required({ msg: 'Service ID is verplicht' })]}
            helpText="Service ID uit je Pay.nl beheeromgeving"
          />
        </div>
      </div>
      
      <div className="row">
        <div className="col-md-6">
          <Field
            name="paynl_terminal_code"
            component={renderField}
            type="text"
            label="PIN Terminal Code"
            placeholder="TH-####-####"
            helpText="PIN terminal code voor fysieke betalingen (optioneel)"
          />
        </div>
      </div>
      
      <div className="row">
        <div className="col-12">
          <Field
            name="paynl_test_mode"
            component={SwitcButton}
            type="checkbox"
            label="Test modus"
            helpText="Schakel dit uit voor live betalingen"
          />
        </div>
      </div>
    </>
  );

  const getProviderName = () => {
    switch (provider) {
      case 'mollie': return 'Mollie';
      case 'paynl': return 'Pay.nl';
      default: return provider;
    }
  };

  const getProviderIcon = () => {
    switch (provider) {
      case 'mollie': return 'fas fa-bolt';
      case 'paynl': return 'fas fa-credit-card';
      default: return 'fas fa-cog';
    }
  };

  return (
    <Modal visible={true} onClose={onClose} width={800}>
      <div className="p-0">
      <div className="card border-0">
        <div className="card-header">
          <h4 className="mb-0">
            <i className={`${getProviderIcon()} me-2`}></i>
            {getProviderName()} Configuratie
          </h4>
        </div>
        
        <form onSubmit={handleSubmit(onSubmit)} className="card-body">
          {loading && (
            <div className="overlay-loading">
              <div className="d-flex flex-column align-items-center">
                <i className="fas fa-spinner fa-spin fa-2x mb-2"></i>
                <p>Configuratie opslaan...</p>
              </div>
            </div>
          )}

          {/* General Settings */}
          <div className="row mb-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className="fas fa-cog me-2"></i>
                Algemene Instellingen
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Field
                name="actief"
                component={SwitcButton}
                type="checkbox"
                label="Betaalmethode activeren"
                helpText="Schakel dit in om deze betaalmethode beschikbaar te maken"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Field
                name="beschrijving"
                component={renderField}
                type="textarea"
                rows="3"
                label="Beschrijving"
                placeholder="Optionele beschrijving voor interne referentie"
              />
            </div>
          </div>

          {/* Provider Specific Settings */}
          <div className="row mb-4 mt-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className={`${getProviderIcon()} me-2`}></i>
                {getProviderName()} Instellingen
              </h5>
            </div>
          </div>

          {provider === 'mollie' && renderMollieFields()}
          {provider === 'paynl' && renderPaynlFields()}

          {/* Advanced Settings */}
          <div className="row mb-4 mt-4">
            <div className="col-12">
              <h5 className="border-bottom pb-2">
                <i className="fas fa-cogs me-2"></i>
                Geavanceerde Instellingen
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Field
                name="webhook_url"
                component={renderField}
                type="url"
                label="Webhook URL"
                placeholder="https://yourdomain.com/webhooks/payments"
                helpText="URL waar betalingsupdates naartoe gestuurd worden"
              />
            </div>
            <div className="col-md-6">
              <Field
                name="redirect_url"
                component={renderField}
                type="url"
                label="Redirect URL"
                placeholder="https://yourdomain.com/payment/success"
                helpText="URL waar klanten naartoe worden geleid na betaling"
              />
            </div>
          </div>

          {/* Form Actions */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="d-flex justify-content-end gap-2">
                <button 
                  type="button" 
                  className="btn btn-secondary"
                  onClick={onClose}
                  disabled={loading}
                >
                  <i className="fas fa-times me-1"></i>
                  Annuleren
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={loading || submitting}
                >
                  <i className="fas fa-save me-1"></i>
                  {loading ? 'Opslaan...' : 'Configuratie Opslaan'}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      </div>
    </Modal>
  );
};

// Initialize form with existing values
const initializeForm = (existingConfig) => {
  if (!existingConfig) return {};

  const initialValues = {
    actief: existingConfig.actief || false,
    beschrijving: existingConfig.extra_instellingen?.beschrijving || '',
    webhook_url: existingConfig.extra_instellingen?.webhook_url || '',
    redirect_url: existingConfig.extra_instellingen?.redirect_url || '',
  };

  // Provider-specific values
  if (existingConfig.naam === 'mollie') {
    initialValues.mollie_api_key = existingConfig.configuratie?.mollie_api_key || '';
    initialValues.mollie_test_mode = existingConfig.configuratie?.mollie_test_mode ?? true;
  } else if (existingConfig.naam === 'paynl') {
    initialValues.paynl_token = existingConfig.configuratie?.paynl_token || '';
    initialValues.paynl_service_id = existingConfig.configuratie?.paynl_service_id || '';
    initialValues.paynl_terminal_code = existingConfig.configuratie?.paynl_terminal_code || '';
    initialValues.paynl_test_mode = existingConfig.configuratie?.paynl_test_mode ?? true;
  }

  return initialValues;
};

const BetaalmethodeFormRedux = reduxForm({
  form: 'betaalmethodeForm',
  enableReinitialize: true
})(BetaalmethodeForm);

const mapStateToProps = (state, ownProps) => ({
  initialValues: initializeForm(ownProps.existingConfig)
});

export default connect(mapStateToProps, { saveBetaalmethode })(BetaalmethodeFormRedux);